import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ReactLoading from 'react-loading';
import Translation from '../../utilities/localizationUtility';
import Button from '../../components/Common/Button';
import SearchDatepicker from '../components/search/SearchDatepicker';
import SearchLocationSelect from '../components/search/SearchLocationSelect';
import { stringToBoolean } from '../../utilities/conversionUtility';
import dayjs from '../../../dayjs/dayjs_timezone';
import dayjsLocaleUtils from '../../../dayjs/dayjs_locale_utils';
import './SearchPage.style.css';

export default class SearchPage extends Component {
  constructor(props) {
    super(props);

    this.FilterContainer = React.createRef();

    this.state = {
      containerHeight: props.setting.mode === 'inline' ? 'fit-content' : '310px',
      isFetchedProduct: false,
      locale: null,
    };
  }

  componentDidMount() {
    const { searchActions: { fetchLocations }, setting: { max_width } } = this.props;
    if (fetchLocations) fetchLocations({ per: 100 });
    const wrapper = this.FilterContainer.current;
    const height = wrapper && wrapper.clientHeight ? wrapper.clientHeight + 15 : 75;
    this.resize(max_width, height);
    const { onTrigger } = this.props;
    onTrigger && onTrigger('widgetDidMount', this.buttonDetails());
    window.addEventListener('resize', this.modifyHeight.bind(this));
    this.setLocale();
  }

  setLocale() {
    const localeData = dayjs().locale(this.props.region).localeData();
    const months = localeData.months();
    const days = localeData.weekdaysMin();
    const locale = {
      localize: {
        day: n => days[n],
        month: n => months[n]
      },
      formatLong: {
        date: () => 'mm/dd/yyyy'
      }
    }

    this.setState({ locale: locale })
  }

  componentDidUpdate() {
    const { setting: { max_width } } = this.props;
    const width = max_width > 0 ? max_width : 450;
    this.modifyWidth(max_width);
  }

  resize(width, height) {
    const { onTrigger } = this.props;
    onTrigger && onTrigger('resize', [`${width}px`, `${height}px`]);
  }

  modifyWidth(width) {
    const { onTrigger } = this.props;
    onTrigger && onTrigger('resize', [`${width}px`]);
  }

  modifyHeight() {
    const { onTrigger } = this.props;
    const wrapper = this.FilterContainer.current;
    const height = wrapper && wrapper.clientHeight ? wrapper.clientHeight + 15 : 75;
    onTrigger && onTrigger('resize', [null, `${height}px`]);
  }

  buttonDetails() {
    const { style: { body = {}, button = {} } } = this.props;
    const t = new Translation(this.props);

    return {
      label: t.key('popUpButton'),
      styles: `
        .bta-widget-show-button:hover {
          background-image: initial !important;
          box-shadow: 0px 0px 6px 1px rgb(0 0 0 / 75%);
          // color: ${button.hover.color};
        }
        .bta-widget-show-button {
          color: ${button.color};
          background-color: ${button.backgroundColor};
          border: 1px solid transparent;
          border-radius: 2px;
          font-family: ${body.fontFamily};
          font-size: calc(16px + 4px);
          font-weight: 700;
          line-height: normal;
          min-width: 110px;
          padding: 9px;
          white-space: pre-wrap;
        }
      `,
    };
  }

  onSubmit() {
    const { onTrigger } = this.props;
    if (onTrigger) onTrigger('replace', this.buildParams());
  }

  buildParams() {
    const { finish, selectedLocation, start } = this.props;
    const params = {
      start: start.format('YYYY-MM-DD'),
      finish: finish.format('YYYY-MM-DD'),
    };

    if (selectedLocation) params.locations = selectedLocation.name;

    return new URLSearchParams(params).toString();
  }

  onOpen() {
    this.setState({ containerHeight: 310 });
  }

  onClose() {
    this.setState({ containerHeight: this.props.setting.mode === 'inline' ? 'fit-content' : '310px' });
  }

  render() {
    const {
      loading,
      region,
      setting,
      style,
    } = this.props;
    const { locale } = this.state;
    const showLocationChooser = stringToBoolean(setting.show_location_chooser);
    const t = new Translation(this.props);

    return (
      <div className="search-container center" style={{ ...style.body, ...style.boxShadow, ...{ background: 'none', height: this.state.containerHeight } }}>
        <div className="filter-container" style={{ ...style.body }} ref={this.FilterContainer}>
          { showLocationChooser &&
            <div style={{width: '100%'}}>
              <SearchLocationSelect
                onMenuOpen={this.onOpen.bind(this)}
                onMenuClose={this.onClose.bind(this)}
              />
            </div>
          }
          <div className="general-filter-container">
            <div className="datepickers-container">
              <SearchDatepicker
                onOpen={this.onOpen.bind(this)}
                onClose={this.onClose.bind(this)}
                region={region}
                locale={locale}
                translation={t}
                type="start"
              />
              <SearchDatepicker
                onOpen={this.onOpen.bind(this)}
                onClose={this.onClose.bind(this)}
                region={region}
                locale={locale}
                translation={t}
                type="finish"
              />
            </div>
            <Button
              styled={{ ...style.button, ...{ margin: '15px 2px 10px 2px', borderRadius: '10px' } }}
              truncate
              className="search-button mt15"
              onClick={this.onSubmit.bind(this)}>
              {loading
                ? (
                <ReactLoading
                  type="bubbles"
                  color={style.body ? style.body.color : null}
                  height={25}
                  width={25}
                />
                )
                : t.key('searchButton')}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}

SearchPage.propTypes = {
  timeZone: PropTypes.string,
  xPropMode: PropTypes.string,
  translation: PropTypes.object,
  defaultTranslation: PropTypes.object,
  setting: PropTypes.shape({
    number_of_events: PropTypes.string,
    filter_tags: PropTypes.arrayOf(PropTypes.object),
  }),
  defaultSetting: PropTypes.object,
  products: PropTypes.arrayOf(PropTypes.object),
  onTrigger: PropTypes.any,
};
